import http from "../utils/http";

export const getContractCategory = async (): Promise<Response> => {
  return await http.get(`/api/contract-categories`);
};
